export interface LoginDto {
  username: string;
  password: string;
  mfaCode?: string;  // Used only for Google Authenticator MFA, not for Duo Universal Prompt
}

export const loginInit: LoginDto = { username: '', password: '', mfaCode: '' };

export interface TokenDto {
  userName: string;
  userPassword: string;
  userId: string;
  employerId: string;
  contactId: string;
  authToken: string;
  validTo: string; //($date - time)
  refreshToken: string;
  fullName: string;
  roles: string[];
  employers: string[];
  expiresIn: number;
  isPasswordExpired: boolean;
  tenant?: string;  // Tenant enum value as string

  // MFA
  mfaRequired?: boolean;
  useDuoMfa?: boolean;
  qrUrl?: string;
  enrollmentUrl?: string;
  duoAuthUrl?: string;  // New: full redirect URL for Universal Prompt
  host?: string;  // Deprecated: kept for backward compatibility
  sig?: string;  // Deprecated: kept for backward compatibility
}

export const tokenInit: TokenDto = {
  userName: '',
  userPassword: '',
  userId: '',
  employerId: '',
  contactId: '',
  authToken: '',
  validTo: '',
  refreshToken: '',
  fullName: '',
  roles: [],
  employers: [],
  expiresIn: 0,
  isPasswordExpired: false,
  tenant: undefined,
};

/**
 * Session information DTO containing only non-sensitive metadata.
 * Used by /api/account/current-token endpoint to return session info without exposing AuthToken.
 * NOTE: This DTO intentionally does NOT include AuthToken or RefreshToken (stored in HttpOnly cookies only).
 */
export interface SessionInfoDto {
  userId: string;
  userName: string;
  fullName: string;
  roles: string[];
  employers: string[];
  contactId: string;
  employerId: string;
  tenant: string;  // Tenant enum value as string
  validTo: string;  // ISO date string
  expiresIn: number;
  isPasswordExpired: boolean;
}
